module.exports = __webpack_public_path__ + "static/media/reporte2014.ba4bed86.png";